import { ExportOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Layout, Modal, message, theme } from "antd";
import CompanyLogo from "assets/aktos-logo-1004x923.png";
import { resetStateAction } from "common/redux/resetStateAction";
import { useFetchMeQuery, useLogoutMutation } from "features/auth/authAPI";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useWhiteLabel } from "providers/whiteLabelProvider";

const { Header } = Layout;

const StyledLogo = styled("img")`
  margin-left: 8px;
  cursor: pointer;
  height: 48px;
  max-width: 220px;
  object-fit: contain;
`;

const StyledCaret = styled.div`
  margin-left: 6px;
  margin-right: 16px;
  font-size: 16px;
  margin-top: -4px;
  transform: rotate(180deg);
`;

const StyledName = styled.span`
  text-transform: capitalize;
`;

const StyledAvatar = styled(Avatar)`
  vertical-align: middle;
  margin-right: 4px;
`;

const StyledMenu = styled("span")`
  user-select: none;
  cursor: pointer;
`;

const StyledProfileMenu = styled(StyledMenu)`
  height: 100%;
  display: flex;
  align-items: center;
`;

const StyledHeader = styled(Header)`
  min-width: 470px;
  z-index: 10;
  position: fixed;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 470px) {
    display: none;
  }
  &&& {
    padding-inline: 0;
  }
`;

const StyledUserActions = styled.div`
  float: right;
  @media only screen and (max-width: 320px) {
    background: #fff;
    color: #404fc7;
  }
  &:hover {
    color: gray;
    .ant-avatar {
      background: lightgray;
    }
  }
`;

function DashboardHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: currentUser } = useFetchMeQuery();
  const [logout] = useLogoutMutation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const { isWhiteLabeled, logo } = useWhiteLabel();

  const onLogout = () => {
    Modal.confirm({
      title: "Logout",
      content: "Are you sure you want to log out?",
      icon: <LogoutOutlined />,
      onCancel: () => {
        /** No need to define body */
      },
      onOk: async () => {
        const result = await logout();
        if ("data" in result) {
          await dispatch(resetStateAction());
          message.success("Logged out successfully.", 2);
          if (result.data?.ssoLogoutUrl?.startsWith("https://")) {
            window.location.href = result.data.ssoLogoutUrl;
          }
        }
      },
    });
  };

  const items = [
    {
      key: "logout",
      icon: <ExportOutlined />,
      label: "Log Out",
      actionHandler: onLogout,
    },
  ];

  const onDropdownClick = ({ item, key, keyPath, domEvent }) => {
    // This prevents navigation to invoice detail when clicking on a dropdown item
    domEvent.preventDefault();
    domEvent.stopPropagation();

    // Call the action handler defined in the items dictionary
    item.props.actionHandler();
  };

  return (
    <StyledHeader
      style={{
        padding: 0,
        background: colorBgContainer,
      }}
    >
      <StyledLogo src={isWhiteLabeled ? logo : CompanyLogo} onClick={() => navigate("/")} />
      <StyledUserActions>
        <Dropdown
          menu={{
            // @ts-ignore
            items,
            onClick: (clickHandlerProp) => onDropdownClick(clickHandlerProp),
          }}
          trigger={["click"]}
        >
          <StyledProfileMenu>
            <StyledAvatar shape="circle" size="small" icon={<UserOutlined />} />
            {currentUser?.name && <StyledName>{currentUser.name.toLowerCase()}</StyledName>}
            <StyledCaret>^</StyledCaret>
          </StyledProfileMenu>
        </Dropdown>
      </StyledUserActions>
    </StyledHeader>
  );
}

export default DashboardHeader;
